// extracted by mini-css-extract-plugin
export var loadingStep = "DepositWizard-module--loadingStep--66f05";
export var noMethods = "DepositWizard-module--noMethods--94ce9";
export var titleSkeleton = "DepositWizard-module--titleSkeleton--6ecfb";